module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "loader_label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "loader"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-532de4f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/loader.vue
// module id = 549
// module chunks = 1